import { get } from '.'

export const Custom = {
	getGimGoodTypes: () => get('/v1/master/goodtypes', {
		baseURL: 'https://qa2.gim.com.bd/ejogajog/api/'
	})
}
